import React from 'react';
import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

function getDegrees(dir: 'left' | 'top' | 'bottom' | 'right'): number {
  switch (dir) {
    case 'left':
      return 90;
    case 'top':
      return 180;
    case 'right':
      return -90;
    case 'bottom':
      return 0;
    default:
      return 0;
  }
}

interface IArrowIcon {
  dir?: 'left' | 'top' | 'bottom' | 'right';
}

const ArrowIcon: React.FC<SvgIconProps & IArrowIcon> = ({
  viewBox = '0 0 12 12',
  dir = 'bottom',
  style,
  ...rest
}) => (
  <SvgIcon
    {...rest}
    viewBox={viewBox}
    style={{ transform: `rotate(${getDegrees(dir)}deg)`, ...style }}
  >
    <path d="M3.55605433,4 L6.109,6.628 L8.66044549,4.00163363 L9.46649981,4.78468841 L6.915,7.411 L6.91649981,7.41241189 L6.11020794,8.24267287 L6.109,8.241 L6.10629188,8.2443065 L5.3,7.41404552 L5.302,7.411 L2.75,4.78305479 L3.55605433,4 Z"></path>
  </SvgIcon>
);

export default ArrowIcon;
